import { render, staticRenderFns } from "./RegistryTemplates.vue?vue&type=template&id=468c38b7&"
import script from "./RegistryTemplates.vue?vue&type=script&lang=js&"
export * from "./RegistryTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports